import { useState } from "react";
import { useOrgUsers } from "@/common/artemis-operations/members";
import { EditableClickable } from "../base-details";
import { UserSearchSelect } from "./user-search-select";

interface OwnerFieldProps {
	ownerId?: string | null;
	/** Scopes the picker to this workspace's members — only they can be owners. */
	workspaceId: string;
	/** Hands ownership to the picked user. When omitted, the owner is read-only. */
	onSave?: (userId: string) => void;
}

/** A resource's owner as a name; with `onSave`, the edit-pen swaps in a member search. */
export function OwnerField({ ownerId, workspaceId, onSave }: OwnerFieldProps) {
	const { data: orgUsers } = useOrgUsers();
	const [editing, setEditing] = useState(false);

	const user = ownerId
		? (orgUsers ?? []).find((u) => u.id === ownerId)
		: undefined;
	const label = !ownerId
		? "-"
		: user
			? user.displayName || user.email
			: ownerId;

	if (!onSave) return <>{label}</>;
	if (!editing)
		return (
			<EditableClickable onClick={() => setEditing(true)}>
				{label}
			</EditableClickable>
		);
	return (
		<UserSearchSelect
			workspaceId={workspaceId}
			autoFocus
			style={{ minWidth: 240 }}
			onChange={(id) => {
				if (id !== ownerId) onSave(id);
				setEditing(false);
			}}
			onBlur={() => setEditing(false)}
		/>
	);
}
